<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">小黑屋</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src class="nav-img none" />
        </div>
      </div>

      <ul class="complain-block" v-for="(item,index) in arr" :key="index" >
        <li>
            <div class="ub ub-pc complain-item">
                <img :src="item.photo" class="complain-img" />
                <div class="complain-info ub ub-ver ub-f1">
                  <div class="complain-name ub">
                      <span>{{ item.nick }}</span>
                      <div class="age">
                      <span>{{ item.age_range }}</span>
                      </div>
                  </div>
                  <div class="num">
                      <span>豪气值: <label>{{ item.coin_total }}</label></span>
                      <span>魅力值: <label>{{ item.score_total }}</label></span>
                  </div>
                  <div class="lahei_dtm">
                    <span>拉黑时长: {{ item.block_time }}</span>
                  </div>
                </div>
                
                <div class="btn-block ub ub-ver ub-pc ub-ac">
                <div class="btn ub ub-pc ub-ac" @click="relieve(item)">
                    <span>解除</span>
                </div>
                </div>
            </div>
            <div class="menu-line"></div>
            </li>
        </ul>
  
        <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="arr.length == 0" >
            <img src="../../assets/img/new2024/no-information.png" alt="">
            <span class="tip-404">暂无拉黑数据</span>
        </div>
    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  export default {
    data() {
      return {
        arr: [],
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo","act_push_mycomplain"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page() {
        var uid = this.$store.state.uid;
        var self = this;
        this.get({
          url: "/App/Get_XiaoHeiWu/?uid=" + uid,
          success: function (data) {
            for (var i in data) {
              var user_item = data[i];
              user_item.photo = self.$store.state.url + "/photo/" + user_item.photo;
              user_item.dtm = user_item.dtm.replace(/-/g, "/");
              user_item.block_time = self.get_block_time(user_item.dtm);
            }
            self.arr = data;
          },
        });
      },

      //解除拉黑
      relieve(info) {
        var uid = this.$store.state.uid;
        var self = this;
        // //将store存储的拉黑数据也移除
        var my_complain = this.$store.state.my_complain;
        my_complain = my_complain.filter(item => item.uid !== info.uid);
        this.$store.commit("set_my_complain", my_complain);
        
        this.get({
          url: "/App/Free_Lahei/?uid_from=" + uid + "&uid_to=" + info.uid,
          success: function (data) {
            if (data == 1) {
              self.$toast.center("解除成功");
              self.init_page();
            }
          },
        });
      },

      get_block_time(dtm) {
        var rtn = "";
        var dtm = new Date(dtm);
        var second = tool.dateDiff_Now(dtm);
        
        if (second < 60) {
            rtn = "刚刚";
        } 
        if (second >= 60 && second < 60 * 60) {
            var minutes = Math.floor(second / 60);
            rtn = minutes + "分钟";
        } 
        if (second >= 60 * 60 && second < 60 * 60 * 24) {
            var hours = Math.floor(second / (60 * 60));
            rtn = hours + "小时";
        } 
        if (second >= 60 * 60 * 24) {
            var days = Math.floor(second / (60 * 60 * 24));
            rtn = days + "天";
        }
        return rtn;
      }

    },
  };
  </script>
  
<style lang="scss" scoped>
.container {
    min-height: 100vh;
    background-color: #FDFDFD;
}

.complain-block {
  overflow-x: hidden; /*隐藏ul x轴的滚动条*/
  padding: 0;
  margin: 0;
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.complain-item {
    padding: 0.5rem 0.8rem;
    .complain-img {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
    }
    .complain-info {
      margin-left: 1rem;
      .complain-name {
        span {
          font-size: 0.9rem;
          font-weight: bold;
          color: #333;
        }
        .age span{
          padding: 0.2rem 0.5rem;
          margin-left: 0.5rem;
          font-size: 0.65rem;
          color: #666;
          border: 1px solid #dcdcdc;
          border-radius: 1rem;
        }
      }
      .num {
        margin-top: 0.5rem;
        span {
          font-size: 0.75rem;
          color: #333;
          label {
            font-size: 0.65rem;
            font-weight: bold;
            color: #BA61FF;
          }
        }
      }
      .num span:last-child{
        margin-left: 1rem;
      }
      .lahei_dtm {
        margin-top: 0.5rem;
        span {
          font-size: 0.75rem;
          color: #333;
        }
      }
    }
    .btn-block {
      .btn {
        margin-top: 0.5rem;
        padding: 0.2rem 1rem;
        background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
        border-radius: 1rem;
        span {
          font-size: 0.75rem;
          color: #fff;
        }
      }
    }
  }

  .no-404 {
    margin-top: 10rem;
    background-size: 100% 100%;
    .tip-404 {
      margin-top: 1rem;
      font-size: 0.75rem;
      color: #666;
    }
  }

.container-dark {
    background-color: #2F2E33;
    .complain-block {
    .complain-item {
      .complain-info {
        .complain-name {
          span {
            color: #FDFDFD;
          }
        }
        .num {
          span {
            color: #FDFDFD;
          }
        }
      }
      .btn-block {
        .day-online {
          span {
            color: #FDFDFD;
          }
        }
      }
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
  .no-404 {
    .tip-404 {
      color: #dfdfdf;
    }
  }
}
  </style>
  